import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { ModalComponent } from '../../shared/modal/modal.component';
import { InputNumberModule } from 'primeng/inputnumber';
import _ from 'lodash';
import { CustomFormControl } from '../../shared/shared.model';

@Component({
  selector: 'app-subjects',
  imports: [InputTextModule, DatePickerModule, CommonModule,
    ReactiveFormsModule, PanelModule, CardModule, ButtonModule, ModalComponent,InputNumberModule],
  templateUrl: './subjects.component.html',
  styleUrl: './subjects.component.scss'
})
export class SubjectsComponent implements OnInit {
  constructor(private fb: FormBuilder) { }

  @Input() formData: any;
  @Output() formChanged = new EventEmitter<void>();
  @Input() orderType: any;
  formGroup!: FormGroup;
  showDeleteModal: boolean = false;
  itemToDelete: any;
  maxDate: Date = new Date();

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'subjects': new FormArray([this.createSubjectFormGroup()])
    });
    if(this.formData) {
      this.initializeFormData();
    }

    this.formGroup.valueChanges.subscribe(()=>{
      this.formChanged.emit();
    });
  }

  /**
   * Gets the subjects form array.
   * @returns The FormArray of subjects.
   */
  get subjects(): FormArray {
    return this.formGroup.get('subjects') as FormArray;
  }

  /**
   * Adds a new subject to the subjects form array.
   */
  addNewSubject(): void {
    this.subjects.push(this.createSubjectFormGroup());
  }

  /**
   * Removes a subject from the subjects form array.
   * @param index The index of the subject to remove.
   */
  removeSubject(index: number) {
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  createSubjectFormGroup(item?: any): FormGroup {
    return new FormGroup({
      'recordSubjectName': new CustomFormControl(item ? item.recordSubjectName : null, 'Record Subject Name', [Validators.required]),
      'alias': new FormControl(item ? item.alias : null),
      'dateOfBirth': new CustomFormControl(item ? item.dateOfBirth : null, 'Date of Birth', [Validators.required]),
      'ssn': new FormControl(item ? item.ssn : null),
      'dateOfDeath': new FormControl(item ? item.dateOfDeath : null),
    });
  }

  /**
 * Highlights a control for validation.
 */
  isError(controlId: any, control?: any) {
    let formControl = this.formGroup.get(controlId);
    if (!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  delete() {
    if (this.itemToDelete >= 0) {
      this.subjects.removeAt(this.itemToDelete);
      this.itemToDelete = null;
      this.showDeleteModal = false;
    }

  }

  initializeFormData() {
    if (this.formData?.subjects) {
      this.subjects.clear();
      _.forEach(this.formData.subjects, subject => {
        this.subjects.push(this.createSubjectFormGroup(subject));
      })
    }

  }

  onSsnChange(event: any, index: number) {
    let ssnControl = this.subjects.at(index).get('ssn');
   
    if (event.value && _.toString(event.value).length > 0) {
      ssnControl?.setValidators([Validators.pattern(/^\d{4}$/)]); 
    } else {
      ssnControl?.clearValidators(); 
    }
    // ssnControl?.markAsTouched();
    ssnControl?.updateValueAndValidity(); 
  }
  
}
